import React, { FC } from 'react';
import { useWatch } from 'react-hook-form';

import CheckboxField from 'buyside/components/presentation/Fields/checkboxField';

const PositionDisclaimerFundField: FC<{ label: string }> = ({ label }) => {
  const employerId = useWatch({ name: 'employerId' });

  return (
    <CheckboxField
      disabled={!employerId}
      label={label}
      name="positionDisclaimerFund"
      size="small"
    />
  );
};

export default PositionDisclaimerFundField;
